import { AnalyticsBoundRule } from '../analytics';

export function extendSupportAssistant(rule: AnalyticsBoundRule): AnalyticsBoundRule {
  rule.extendWhen('[data-open-support-chat]', (extension) =>
    extension.set({
      assistant_name: 'Athena Virtual Support Assistant',
      action: 'open',
      result: 'initiated',
      entry_point: 'chat_now_button',
    })
  );
  return rule;
}